/*global chrome*/

import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { getUser, getToken, resetUserSession } from './service/AuthService';
import { setUserGoal } from './service/GoalService';
import ProblematicLogEntry from './ProblematicLogEntry';
import AudioRecorder from './AudioRecorder'
import Stopwatch from "./Stopwatch";
import Iframe from './Iframe'
import IframeWeb from './IframeWeb'
import Loading from './Loading'
import BrowserNotifications from "./BrowserNotifications";
import { FailureReasonsTextField, TimeSpentSelect, WorkoutTimeSelect, TimeCommitmentSelect, TreatmentsSelect, CaplanScaleNO3Slider, CaplanScaleNO2Slider, CaplanScaleNO1Slider, CaplanScaleCIU3Slider, CaplanScaleCIU2Slider, CaplanScaleCIU1Slider, CaplanScaleCP3Slider, CaplanScaleCP2Slider, CaplanScaleCP1Slider, CaplanScaleMR3Slider, CaplanScaleMR2Slider, CaplanScaleMR1Slider, CaplanScalePOSI1Slider, CaplanScalePOS2Slider, CaplanScalePOS3Slider,  GoalTextField, ProblematicBehaviorsSelect, JoiningReasonSelect, GenderSelect, DOBDatePicker, MaterialResetPassword, MaterialResetPasswordConfirm } from './MaterialComponents';
import { OnboardingFriendAdvice, OnboardingGoalsWeek, OnboardingGoalsMonth, OnboardingGoalsQuarter, OnboardingGoalsYear, OnboardingVizSuccess, OnboardingAboutYou, MateriaBasicTextField} from './MaterialComponents';
import './css/Checkbox.css';
import './css/Daily.css';
import './css/Timeline.css';
import './css/PopupForm.css';
import './css/Success.css';

import closeBttn from './assets/closeBttnSquare.svg';
import nextBttn from './assets/nextBttn.svg';



//TODO: move this to an environment variable
const onboardingrUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/onboarding';
const dateObj = new Date()

//TODO: personalize this and fetch it from the server
function fetchPersonalizedPlan(){
    let html =
    `<strong>Your Personalized Digital Wellness Plan Powered by Trampoline Health</strong><br><br>
Your journey to healthier screen habits starts now. Trampoline Health provides personalized support, relapse prevention,
and community to keep you accountable. The more you engage, the smarter and more accurate your tailored plan becomes.<br><br>
<hr><br>
<strong>1. Understanding Your Digital Habits</strong><br><br>
<strong>Time Impact:</strong> Even small shifts in screen habits can free up more time for focus, relaxation, and
personal growth. As you track more, we’ll provide insights on where time can be reclaimed.<br><br>
<strong>Patterns & Trends:</strong> Tracking your habits will reveal high-risk times, emotional triggers, and usage
spikes—helping you regain control before overuse happens.<br><br>
<strong>Energy & Focus:</strong> Excessive screen time affects mental clarity and motivation. As you engage with the
platform, we’ll pinpoint small changes that boost focus and well-being.<br><br>
<strong>Next Step:</strong> Complete your first Digital Wellness Workout to start identifying patterns and building
healthier habits.<br><br>
<hr><br>
<strong>2. Recognizing Your Triggers</strong><br><br>
<strong>Common Triggers:</strong> Most people overuse screens due to stress, boredom, procrastination, or habit loops.
The more you track, the better we can help you manage your specific triggers.<br><br>
<strong>High-Risk Situations:</strong> Your most vulnerable times—like late nights, social media breaks, or unstructured
moments—will become clearer as you track. Recognizing these patterns is the first step to change.<br><br>
<strong>Device-Specific Risks:</strong> Some platforms are designed to maximize engagement. We’ll help you identify
which apps disrupt your focus the most and how to regain control.<br><br>
<strong>Next Step:</strong> Log your first setback to begin identifying your unique patterns.<br><br>
<hr><br>
<strong>3. Building a Sustainable System</strong><br><br>
<strong>Alternative Activities:</strong><br>
<strong>Boredom:</strong> Read a book, go for a walk, or listen to a podcast.<br>
<strong>Stress Relief:</strong> Practice deep breathing, mindfulness, or stretching.<br>
<strong>Procrastination:</strong> Use a focus timer (like Pomodoro) to stay on track.<br><br>
<strong>Environmental Adjustments:</strong><br>
Keep your phone outside the bedroom at night.<br>
Create a work-only space free from digital distractions.<br><br>
<strong>Accountability & Support:</strong> Join the Trampoline Health Community to ask questions, share progress, and
stay accountable.<br><br>
<strong>Next Step:</strong> Introduce yourself in the Trampoline Health Community and set a personal goal for the
week.<br><br>
<hr><br>
<strong>4. Setting Boundaries That Work</strong><br><br>
<strong>Non-Negotiable Rules:</strong><br>
No screens one hour before bed.<br>
No phone use during meals or social time.<br>
Work-first approach (no social media before finishing key tasks).<br><br>
<strong>Recognizing ‘Stop Signals’:</strong> Signs like guilt, stress, or fatigue after screen overuse mean it’s time to
pause. Logging these moments will help you spot them faster.<br><br>
<strong>Reducing Distractions:</strong><br>
Turn off non-essential notifications.<br>
Move distracting apps off your home screen.<br>
Set up Focus Modes or scheduled "Do Not Disturb" periods.<br><br>
<strong>Next Step:</strong> Set a small boundary goal inside the Trampoline Health community and track your progress
there.<br><br>
<hr><br>
<strong>5. Responding to Setbacks</strong><br><br>
<strong>Recognizing Early Warning Signs:</strong> If you notice anxiety, mindless scrolling, or avoidance behaviors,
it’s time to pause and reflect. Logging these moments will help prevent them from becoming habits.<br><br>
<strong>Adjusting Based on Risk Level:</strong><br>
<strong>Mild distraction:</strong> Take a short break and reset.<br>
<strong>Moderate overuse:</strong> Switch to an alternative activity and note what triggered it.<br>
<strong>Severe habit disruption:</strong> Seek support in the Trampoline Health Community or revisit your
Prevention Plan.<br><br>
<strong>Learning from Relapses:</strong> Every setback is an opportunity to adjust and improve. Tracking them helps you
see progress over time.<br><br>
<strong>Next Step:</strong> Log a recent setback in the app and review your patterns.<br><br>
<hr><br>
<strong>Next Steps with Trampoline Health</strong><br><br>
Your plan evolves with you. The more you engage, the more personalized and effective it becomes.<br><br>
<strong>1. Complete your first Digital Wellness Workout.</strong><br>
Helps you identify patterns and create a personalized improvement plan.<br><br>
<strong>2. Log your first screen time entry or setback.</strong><br>
Real data enables smarter recommendations tailored to your habits.<br><br>
<strong>3. Join the Trampoline Health Community.</strong><br>
Get support, ask questions, and stay accountable in a judgment-free space.<br><br>
<strong>4. Set one clear boundary goal inside the platform.</strong><br>
Small commitments lead to big, sustainable changes.<br><br>
As you continue, Trampoline Health will provide more personalized recommendations, relapse support, and structured
wellness workouts to help you build sustainable, balanced screen habits.<br><br>
    `
    return html
}


const OnboardingDemo = () => {
    const user = getUser();
    const token = getToken();
    // const name = user !== 'undefined' && user ? user.name: '';
    const username = user !== 'undefined' && user ? user.username: '';

    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setLoading] = useState(true);
    const [dailyContent, setDailyContent] = useState('');


    //Popup
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showLearningPopup, setShowLearningPopup] = useState(false);
    const [showonboardingPopup, setShowonboardingPopup] = useState(false);
    
    const [journalAudio, setAudio] = useState(null);

    const navigate = useNavigate()

    //Onboarding Log 
    const [onboardingIntro, setonboardingIntro] = useState('');
    const [onboardingPass, setonboardingPass] = useState('');
    const [onboardingTime, setonboardingTime] = useState('');
    const [onboardingBackground, setonboardingBackground] = useState('');
    const [onboardingInformation, setonboardingInformation] = useState('');
    const [onboardingWhy, setonboardingWhy] = useState('');
    const [onboardingImpact, setonboardingImpact] = useState('');
    const [onboardingScreen, setOnboardingScreen] = useState('');
    const [onboardingScreen2, setOnboardingScreen2] = useState('');
    const [onboardingScreen3, setOnboardingScreen3] = useState('');
    const [onboardingScreen4, setOnboardingScreen4] = useState('');
    const [onboardingSuccess, setonboardingSuccess] = useState('');


    //new onboarding screens
    const [onboardingScreenAboutYou, setOnboardingScreenAboutYou] = useState('');
    const [onboardingScreenVizSuccess, setOnboardingScreenVizSuccess] = useState('');
    const [onboardingScreenGoalsYear, setOnboardingScreenGoalsYear] = useState('');
    const [onboardingScreenGoalsThreeMonth, setOnboardingScreenGoalsThreeMonth] = useState('');
    const [onboardingScreenGoalsMonth, setOnboardingScreenGoalsMonth] = useState('');
    const [onboardingScreenGoalsWeek, setOnboardingScreenGoalsWeek] = useState('');
    const [onboardingScreenFriendAdvice, setOnboardingScreenFriendAdvice] = useState('');
    const [relapsePlan, setRelapsePlan] = useState('');
    
    //Relapse Prevention Plan
    const [relapsePlanText, setRelapsePlanText] = useState(fetchPersonalizedPlan());



    //Learning Form Data (move it here)
    //Updated questions after new landing form
    const [aboutYou, setAboutYou] = useState('');
    function handleAboutYou(newValue) {
        setAboutYou(newValue);
    }
    const [vizSuccess, setVizSuccess] = useState('');
    function handleVizSuccess(newValue) {
        setVizSuccess(newValue);
    }
    const [goalsYear, setGoalsYear] = useState('');
    function handleGoalsYear(newValue) {
        setGoalsYear(newValue);
    }
    const [goalsQuarter, setGoalsQuarter] = useState('');
    function handleGoalsQuarter(newValue) {
        setGoalsQuarter(newValue);
    }
    const [goalsMonth, setGoalsMonth] = useState('');
    function handleGoalsMonth(newValue){
        setGoalsMonth(newValue);
    }
    const [goalsWeek, setGoalsWeek] = useState('');
    function handleGoalsWeek(newValue) {
        setGoalsWeek(newValue);
    }
    const [friendAdvice, setFriendAdvice] = useState('');
    function handleFriendAdvice(newValue) {
        setFriendAdvice(newValue);
    }

    const [newPassword, setNewpassword] = useState('');
    function handleNewpassword(newValue) {
        setNewpassword(newValue);
    }
    const [newPasswordConfirm, setNewpasswordConfirm] = useState('');
    function handleNewpasswordConfirm(newValue) {
        setNewpasswordConfirm(newValue);
    }
    const [dateofbirth, setDateofbirth] = useState('');
    function handleDateofbirth(newValue) {
        setDateofbirth(newValue);
    }

    const [gender, setGender] = useState('');
    function handleGender(newValue) {
        setGender(newValue);
    }

    const [name, setName] = useState('');
    function handleName(newValue) {
        setName(newValue);
    }

    const [joiningReason, setJoiningReason] = useState('');
    function handleJoiningReason(newValue) {
        setJoiningReason(newValue);
    }

    const [timeSpent, setTimeSpent] = useState('');
    function handleTimeSpent(newValue) {
        setTimeSpent(newValue);
    }

    const [problematicBehaviors, setProblematicBehaviors] = useState('');
    function handleProblematicBehaviors(newValue) {
        setProblematicBehaviors(newValue);
    }

    const [caplanScalePOSI1, setCaplanScalePOSI1] = useState('');
    function handleCaplanScalePOSI1(newValue) {
        setCaplanScalePOSI1(newValue);
    }

    const [caplanScalePOSI2, setCaplanScalePOSI2] = useState('');
    function handleCaplanScalePOSI2(newValue) {
        setCaplanScalePOSI2(newValue);
    }

    const [caplanScalePOSI3, setCaplanScalePOSI3] = useState('');
    function handleCaplanScalePOSI3(newValue) {
        setCaplanScalePOSI3(newValue);
    }

    const [caplanScaleMR1, setCaplanScaleMR1] = useState('');
    function handleCaplanScaleMR1(newValue) {
        setCaplanScaleMR1(newValue);
    }

    const [caplanScaleMR2, setCaplanScaleMR2] = useState('');
    function handleCaplanScaleMR2(newValue) {
        setCaplanScaleMR2(newValue);
    }

    const [caplanScaleMR3, setCaplanScaleMR3] = useState('');
    function handleCaplanScaleMR3(newValue) {
        setCaplanScaleMR3(newValue);
    }

    const [caplanScaleCP1, setCaplanScaleCP1] = useState('');
    function handleCaplanScaleCP1(newValue) {
        setCaplanScaleCP1(newValue);
    }

    const [caplanScaleCP2, setCaplanScaleCP2] = useState('');
    function handleCaplanScaleCP2(newValue) {
        setCaplanScaleCP2(newValue);
    }

    const [caplanScaleCP3, setCaplanScaleCP3] = useState('');
    function handleCaplanScaleCP3(newValue) {
        setCaplanScaleCP3(newValue);
    }

    const [caplanScaleCIU1, setCaplanScaleCIU1] = useState('');
    function handleCaplanScaleCIU1(newValue) {
        setCaplanScaleCIU1(newValue);
    }

    const [caplanScaleCIU2, setCaplanScaleCIU2] = useState('');
    function handleCaplanScaleCIU2(newValue) {
        setCaplanScaleCIU2(newValue);
    }

    const [caplanScaleCIU3, setCaplanScaleCIU3] = useState('');
    function handleCaplanScaleCIU3(newValue) {
        setCaplanScaleCIU3(newValue);
    }

    const [caplanScaleNO1, setCaplanScaleNO1] = useState('');
    function handleCaplanScaleNO1(newValue) {
        setCaplanScaleNO1(newValue);
    }

    const [caplanScaleNO2, setCaplanScaleNO2] = useState('');
    function handleCaplanScaleNO2(newValue) {
        setCaplanScaleNO2(newValue);
    }

    const [caplanScaleNO3, setCaplanScaleNO3] = useState('');
    function handleCaplanScaleNO3(newValue) {
        setCaplanScaleNO3(newValue);
    }


    const [triedTreatments, setTriedTreatments] = useState('');
    function handleTriedTreatments(newValue) {
        setTriedTreatments(newValue);
    }

    const [failureReasons, setFailureReasons] = useState('');
    function handleFailureReasons(newValue) {
        setFailureReasons(newValue);
    }

    const [timeCommitment, setTimeCommitment] = useState('');
    function handleTimeCommitment(newValue) {
        setTimeCommitment(newValue);
    }

    const [workoutTime, setWorkoutTime] = useState('');
    function handleWorkoutTime(newValue) {
        setWorkoutTime(newValue);
    }


    const [currentGoal, setCurrentGoal] = useState('');
    function handleCurrentGoal(newValue) {
        setCurrentGoal(newValue);
    }

    //onboarding Entries
    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState('');
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');

    //Spinner
    const loadingSpinner = document.querySelector('.donut');

    
    function setOnboardingForm(){
        // const [onboardingScreenAboutYou, setOnboardingScreenAboutYou] = useState('');
        // const [onboardingScreenVizSuccess, setOnboardingScreenVizSuccess] = useState('');
        // const [onboardingScreenGoalsYear, setOnboardingScreenGoalsYear] = useState('');
        // const [onboardingScreenGoalsThreeMonth, setOnboardingScreenGoalsThreeMonth] = useState('');
        // const [onboardingScreenGoalsMonth, setOnboardingScreenGoalsMonth] = useState('');
        // const [onboardingScreenGoalsWeek, setOnboardingScreenGoalsWeek] = useState('');
        // const [onboardingScreenFriendAdvice, setOnboardingScreenFriendAdvice] = useState('');
        //new questions
        setOnboardingScreenAboutYou(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Let’s start with learning more about you. </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">Tell us about yourself. What background would help us craft your personalized digital wellness plan?</div>
                    <OnboardingAboutYou placeholder="Relevant background details" handleChange={ handleAboutYou }/>
                </div>
            </div> 
        )
        setOnboardingScreenVizSuccess(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Let’s start with learning more about you.  </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">Imagine a life without problematic tech use. What does it look like?</div>
                    <OnboardingVizSuccess placeholder="Describe your life without problematic tech use" handleChange={ handleVizSuccess }/>
                </div>
            </div> 
        )
        setOnboardingScreenGoalsYear(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Setting clear goals is the first step to meaningful longterm change. Think about what matters most to you right now. Who do you want to become? </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">If you could choose just one goal to focus on this year, what would it be?</div>
                    <OnboardingGoalsYear placeholder="Enter your top goal for the year" handleChange={ handleGoalsYear }/>
                </div>
            </div> 
        )
        setOnboardingScreenGoalsThreeMonth(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Setting clear goals is the first step to meaningful longterm change. Think about what matters most to you right now. Who do you want to become? </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">To work toward that goal, what goal would you set for the next three months?</div>
                    <OnboardingGoalsQuarter placeholder="Enter your goal for the next three months" handleChange={ handleGoalsQuarter }/>
                </div>
            </div> 
        )
        setOnboardingScreenGoalsMonth(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Setting clear goals is the first step to meaningful longterm change. Think about what matters most to you right now. Who do you want to become? </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">What’s one specific goal you can set for the next month to support that three-month goal?</div>
                    <OnboardingGoalsMonth placeholder="Enter your goal for this month" handleChange={ handleGoalsMonth }/>
                </div>
            </div> 
        )
        setOnboardingScreenGoalsWeek(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Setting clear goals is the first step to meaningful longterm change. Think about what matters most to you right now. Who do you want to become? </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">What’s one small step you can take this week to move closer to your monthly goal?</div>
                    <OnboardingGoalsWeek placeholder="Enter your goal for this week" handleChange={ handleGoalsWeek }/>
                </div>
            </div> 
        )
        setOnboardingScreenFriendAdvice(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Sometimes, the best advice we give others is the advice we need ourselves. Reflect on what you'd say to support someone starting their journey. </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">What advice would you give a close friend starting this journey of change?</div>
                    <OnboardingFriendAdvice placeholder="Share the advice you’d give a friend" handleChange={ handleFriendAdvice }/>
                </div>
            </div> 
        )

        //separator ----------------

        setonboardingIntro(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ fontSize:' 0.75em'}}> We'd love to learn a bit about you and your goals so we can customize your experience. Please take a moment to fill out our quick onboarding form. With your help, we'll craft the perfect program for you!  </p>
                </div>
                <div className="formBttnContainer" style={{ bottom:' 4rem'}}>
                    <button className="popupButton" onClick={handleNextQuestion} >Jump in!</button>
                    {/* <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleChatNavigate} >Chat Support</button> */}
                </div>
            </div> 
        )
        setonboardingPass(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> First let's reset your password.  </p>
                </div>
                <div>
                    <div className="onboardingQuestion">New Password:</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <MaterialResetPassword handleChange={handleNewpassword} placeholder='Password' />
                </div>
                <div>
                    <div className="onboardingQuestion">Confirm New Password:</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <MaterialResetPasswordConfirm handleChange={handleNewpasswordConfirm} placeholder='Password' />
                </div>
            </div> 
        )
        setonboardingTime(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Let’s start with learning more about you.  </p>
                </div>
                {/* <div>
                    <div className="onboardingQuestion">Date of Birth</div>
                    <DOBDatePicker handleChange={handleDateofbirth}/>
                </div> */}
                <div>
                    <div className="onboardingQuestion">What are you looking to cut back on?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <ProblematicBehaviorsSelect handleChange={handleProblematicBehaviors} label='Behavior(s) - multiple select' elements={['Social Media', 'Video Streaming', 'Gaming', 'Porn', 'Gambling', 'Other']}/>
                </div>
                <div>
                    <div className="onboardingQuestion">Why do you want to join?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <JoiningReasonSelect handleChange={handleJoiningReason} label='Where can we help - multiple select' elements={['Decrease Anxiety', 'Improve Well Being ', 'Improve Relationships ', 'Improve Mental Health', 'Improve Physical Health', 'Decrease Loneliness', 'Increase Self-Fulfillment', 'Improve Sleep', 'Improve Productivity']}/>
                </div>
            </div> 
        )
        setonboardingBackground(
            <div className="learningFeedback">
                {/* <div>
                    <p className="questionInfo"> Let's dig a little deeper.</p>
                </div> */}
                <div>
                    <div className="onboardingQuestion">How long, on average, do you spend on the internet daily?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <TimeSpentSelect  multipleSelect = 'false' handleChange={handleTimeSpent} label='Time' elements={['<3 hours', '3-7 hours', '7-12 hours', '13+ hours ']}/>
                </div>
                <div>
                    <div className="onboardingQuestion">What are you looking to cut back on?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <ProblematicBehaviorsSelect handleChange={handleProblematicBehaviors} label='Behavior(s) - multiple select' elements={['Social Media', 'Video Streaming', 'Porn', 'Gambling', 'Other']}/>
                </div>
                <div>
                    {/* <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div> */}
                    <div className="onboardingQuestion" >What is an important goal that your tech use has gotten in the way of?</div>
                    <GoalTextField handleChange={handleCurrentGoal} placeholder='Goal' />
                </div>
            </div> 
        )
        setonboardingInformation(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo">  Instructions: Please rate how much you agree with each statement below, from 1 (Definitely Disagree) to 8 (Definitely Agree).</p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">I prefer online social interaction over face-to-face communication.</div>
                    <CaplanScalePOSI1Slider value = { caplanScalePOSI1 } handleChange={handleCaplanScalePOSI1} min='1' max='8'/>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">Online social interaction is more comfortable for me than face-to-face interaction.</div>
                    <CaplanScalePOS2Slider handleChange={handleCaplanScalePOSI2} min='1' max='8'/>
                </div>
            </div> 
        )
        setonboardingWhy(
            <div className="learningFeedback">
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">I prefer communicating with people online rather than face-to-face.</div>
                    <CaplanScalePOS3Slider handleChange={handleCaplanScalePOSI3} min='1' max='8'/>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">I have used the Internet to talk with others when I was feeling isolated.</div>
                    <CaplanScaleMR1Slider handleChange={handleCaplanScaleMR1} min='1' max='8'/>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">I have used the Internet to make myself feel better when I was down.</div>
                    <CaplanScaleMR2Slider handleChange={handleCaplanScaleMR2} min='1' max='8'/>
                </div>
            </div> 
        )
        setonboardingImpact(
            <div className="learningFeedback">
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">I have used the Internet to make myself feel better when I’ve felt upset.</div>
                    <CaplanScaleMR3Slider handleChange={handleCaplanScaleMR3} min='1' max='8'/>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">When I haven’t been online for some time, I become preoccupied with the thought of going online.</div>
                    <CaplanScaleCP1Slider handleChange={handleCaplanScaleCP1} min='1' max='8'/>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">I would feel lost if I was unable to go online.</div>
                    <CaplanScaleCP2Slider handleChange={handleCaplanScaleCP2} min='1' max='8'/>
                </div>
            </div> 
        )
        setOnboardingScreen(
            <div className="learningFeedback">
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">I think obsessively about going online when I am offline.</div>
                    <CaplanScaleCP3Slider handleChange={handleCaplanScaleCP3} min='1' max='8'/>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">I have difficulty controlling the amount of time I spend online.</div>
                    <CaplanScaleCIU1Slider handleChange={handleCaplanScaleCIU1} min='1' max='8'/>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">I find it difficult to control my Internet use.</div>
                    <CaplanScaleCIU2Slider handleChange={handleCaplanScaleCIU2} min='1' max='8'/>
                </div>
            </div> 
        )
        setOnboardingScreen2(
            <div className="learningFeedback">
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">When offline, I have a hard time trying to resist the urge to go online.</div>
                    <CaplanScaleCIU3Slider handleChange={handleCaplanScaleCIU3} min='1' max='8'/>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">My internet use has made it difficult for me to manage my life.</div>
                    <CaplanScaleNO1Slider handleChange={handleCaplanScaleNO1} min='1' max='8'/>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">I have missed social engagements or activities because of my Internet use.</div>
                    <CaplanScaleNO2Slider handleChange={handleCaplanScaleNO2} min='1' max='8'/>
                </div>
            </div> 
        )
        setOnboardingScreen3(
            <div className="learningFeedback">
                <div>
                    <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">My Internet use has created problems for me in my life.</div>
                    <CaplanScaleNO3Slider handleChange={handleCaplanScaleNO3} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">What have you tried?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <TreatmentsSelect handleChange={handleTriedTreatments} label='Alternative(s) - multiple select' elements={['Therapy', 'App Blockers', 'Support Group', 'Mindfulness', 'Dumb Phone', 'Physical Limiter', 'Nothing Yet', 'Other']}/>
                </div>
                <div>
                    <div className="onboardingQuestion">Why hasn’t what you’ve tried worked long term?</div>
                    <FailureReasonsTextField handleChange={handleFailureReasons} placeholder="Think about what you have tried and why changes haven't stuck" rows="2"/>
                </div>
            </div> 
        )
        setOnboardingScreen4(
            <div className="learningFeedback">
                <div>
                    <h5 className="questionInfo"> Commit improving your digital use and overall wellness. Let's put in the work.</h5>
                </div>
                <div>
                    <div className="onboardingQuestion" style={{ marginBottom: '1rem' }} >How many times a week do you commit to work on your digital health?</div>
                    <TimeCommitmentSelect handleChange={handleTimeCommitment} multipleSelect='false' label='Times per Week' elements={['3 times', '5 times', '7 times']}/>
                </div>
                <div>
                    {/* <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div> */}
                    <div className="onboardingQuestion" style={{ marginBottom: '1rem' }} >At what time do you plan to do your digital wellness workouts?</div>
                    {/* <MateriaBasicTextField handleChange={handleCurrentGoal} placeholder='Goal' /> */}
                    <WorkoutTimeSelect handleChange={handleWorkoutTime}/>
                </div>
            </div> 
        )
        setonboardingSuccess(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Digital wellness is is a journey not a destination. Creating your personalized road map... </p>
                </div>
                <div style={{ marginTop: '5rem'}} >
                    <Loading/>
                </div>
            </div> 
        )
        setRelapsePlan(
            <div className="learningFeedback">
                <div style={{overflowY: "auto", height: "80%", minHeight:"400px", textAlign: "center" }} dangerouslySetInnerHTML={{__html: relapsePlanText}} >
                </div>
                <div className="formBttnContainer" style={{ bottom: '0rem' }}>
                    <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleCloseRelapsePopup} >Commit To Plan</button>
                </div>
            </div> 
        )
    }



    function stringToHTML (str) {
        // If DOMParser is supported, use it
        let support = true
        if (!window.DOMParser) support = false;
        let parser = new DOMParser();
        try {
            parser.parseFromString('x', 'text/html');
        } catch(err) {
            support = false;
        }
        if (support) {
            let parser = new DOMParser();
            var doc = parser.parseFromString(str, 'text/html');
            //console.log('yo7', dom)
            return doc.body;
        }

        // Otherwise, fallback to old-school method
        var dom = document.createElement('div');
        dom.innerHTML = str;
        //console.log('yooo')
        //console.log('yo7', dom)
        return dom;
    };

    function randomArrVal(arr){
        return arr[Math.floor(Math.random() * arr.length)];
    }
    
    //Popup
        let questionsonboarding = [
        {
            question: "Welcome to Trampoline! Let's Build a Plan",
            assets: onboardingIntro,
            subheading: 'Test',
            input: '<textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea>'
        },
        {
            question: 'Onboarding',
            assets: onboardingPass,
            errorMessage: errorMessage
        },
        {
            question: 'Getting Started',
            assets: onboardingTime,
        },
        {
            question: 'Getting Started',
            assets: onboardingScreenAboutYou,
        },
        {
            question: 'Getting Started',
            assets: onboardingScreenVizSuccess,
        },
        {
            question: 'Goal Setting',
            assets: onboardingScreenGoalsYear,
        },
        // {
        //     question: 'Goal Setting',
        //     assets: onboardingScreenGoalsThreeMonth,
        // },
        // {
        //     question: 'Goal Setting',
        //     assets: onboardingScreenGoalsMonth,
        // },
        // {
        //     question: 'Goal Setting',
        //     assets: onboardingScreenGoalsWeek
        // },
        {
            question: 'Take the First Step',
            assets: onboardingScreenFriendAdvice,
        },
        {
            question: 'Take the First Step',
            assets: onboardingScreen4,
        },
        {
            question: 'Welcome to Trampoline Health!',
            assets: onboardingSuccess,
        },
        {
            question: 'Prevention Plan',
            assets: relapsePlan,
        },
    ];

    //previous questions
    // let questionsonboarding = [
    //     {
    //         question: "Let's Start Your Digital Wellness Journey!",
    //         assets: onboardingIntro,
    //         subheading: 'Test',
    //         input: '<textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea>'
    //     },
    //     {
    //         question: 'Onboarding',
    //         assets: onboardingPass,
    //         errorMessage: errorMessage
    //     },
    //     {
    //         question: 'Onboarding',
    //         assets: onboardingTime,
    //     },
    //     {
    //         question: 'Onboarding',
    //         assets: onboardingBackground,
    //     },
    //     {
    //         question: 'Tech Use Screener',
    //         assets: onboardingInformation,
    //     },
    //     {
    //         question: 'Tech Use Screener',
    //         assets: onboardingWhy,
    //     },
    //     {
    //         question: 'Tech Use Screener',
    //         assets: onboardingImpact,
    //     },
    //     {
    //         question: 'Tech Use Screener',
    //         assets: onboardingScreen,
    //     },
    //     {
    //         question: 'Tech Use Screener',
    //         assets: onboardingScreen2,
    //     },
    //     {
    //         question: 'Tech Use Screener',
    //         assets: onboardingScreen3,
    //     },
    //     {
    //         question: 'Take the First Step',
    //         assets: onboardingScreen4,
    //     },
    //     {
    //         question: 'Welcome to Trampoline Health!',
    //         assets: onboardingSuccess,
    //     },
    // ];

    const handleonboardingSupport = () => {
        //console.log('handling onboarding support')
        setShowPopup(true);
        document.getElementById('learning-popup').style.display = "none";
        document.getElementById('onboarding-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[1].style.visibility =  "visible"
    };

    const handleNextQuestion = () => {
        if ((newPassword !== newPasswordConfirm) && (currentQuestion === 1)){
            //console.log('setting error message')
            setErrorMessage('Passwords do not match. Input your new password again');
            return;
        }
        setErrorMessage("")
        setCurrentQuestion(currentQuestion + 1);
        //console.log('status: ', currentQuestion)
        //console.log('test: ', questionsonboarding[currentQuestion])
        //console.log(questionsonboarding)
        
    };

    const handlePreviousQuestion = () => {
        setCurrentQuestion(currentQuestion - 1);
    };


    const homeHandler = () => {
        document.getElementById('learningContainer').style.display = 'none'
        document.getElementById('homeContainer').style.display = 'block'
    }


    const handleChatNavigate = () => {
        // Update the input value as the answer for the current question
        //console.log('navigate chat')
        navigate('/chat')
    };

    const handleSubmitonboarding = (event) => {
        // Process form submission or save answers
        // For example, you can send the answers to a backend server here

        //Send the stuff to the backend
        // Show a success message or close the popup form
        //console.log('sending the stuff to the back end homie')
        //console.log('start')
        event.preventDefault();
        

        //MUST DO:: need to add messaging to make sure these are all required
        // if(dateofbirth === '' || gender === '' || email === '' || joiningReason === '' || timeSpent === '' || problematicBehaviors === '' || caplanScalePOSI1 === '' || failureReasons === '' || problematicTools === '' || problematicBehaviors === '' || initialUseScore === '' || caplanScalePOSI1 === '' || caplanScalePOSI2 === '' || caplanScaleMR1 === '' || caplanScaleMR2 === '' || caplanScaleMR3 === '' || caplanScaleCP1 === '' || caplanScaleCP2 === '' || caplanScaleCP3 === '' || caplanScaleCIU1 === '' || caplanScaleCIU2 === '' || caplanScaleCIU3 === '' || caplanScaleNO1 === '' || caplanScaleNO2 === '' || caplanScaleNO3 === ''){
        //     setErrorMessage('All fields are required');
        //     return;
        // }

        if (newPassword !== newPasswordConfirm){
            setErrorMessage('Passwords do not match. Input your new password again');
            return;
        }

        //console.log('passed check')
        setErrorMessage(null)
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        //test to make sure we have all the files
        // //console.log('got da password', newPassword)
        // //console.log('got da journal audio', dateofbirth)
        // //console.log('got da goal title', gender)
        // //console.log('got the goal reason', joiningReason)
        // //console.log('got previous goal status', timeSpent)
        // //console.log('got recent tech use', problematicBehaviors)
        // //console.log('got takeaways', caplanScalePOSI1)
        // //console.log('got da journal audio', caplanScalePOSI2)
        // //console.log('got da goal title', caplanScalePOSI3)
        // //console.log('got the goal date', caplanScaleMR1)
        // //console.log('got the goal reason', caplanScaleMR2)
        // //console.log('got previous goal status', caplanScaleMR3)
        // //console.log('got recent tech use', caplanScaleCP1)
        // //console.log('got takeaways', caplanScaleCP2)
        // //console.log('got the goal date', caplanScaleCP3)
        // //console.log('got the goal reason', caplanScaleCIU1)
        // //console.log('got previous goal status', caplanScaleCIU2)
        // //console.log('got recent tech use', caplanScaleCIU3)
        // //console.log('got takeaways', caplanScaleNO1)
        // //console.log('got the goal reason', caplanScaleNO2)
        // //console.log('got previous goal status', caplanScaleNO3)
        // //console.log('got recent tech use', triedTreatments)
        // //console.log('got failure takeaways', failureReasons)
        // //console.log('got the time commitment select', timeCommitment)
        // //console.log('got the workout time in', workoutTime)
        
        console.log(dateObj.getTime())
        const requestBody = {
            username: username,
            token: token,
            date: dateObj.getTime(),
            newPassword: newPassword,
            problematicBehaviors: problematicBehaviors,
            joiningReason: joiningReason,
            aboutYou: aboutYou,
            vizSuccess: vizSuccess,
            goalsYear: goalsYear,
            goalsQuarter: goalsQuarter,
            goalsMonth: goalsMonth,
            goalsWeek: goalsWeek,
            friendAdvice: friendAdvice,
            timeCommitment: timeCommitment,
            workoutTime: workoutTime            
        }


        //console.log(requestBody)
        axios.post(onboardingrUrl, requestBody, requestConfig).then(response => {
            // setUserSession(response.data.user, response.data.token);
            //console.log('sending onboarding data')
            setTimeout(()=>{
                // navigate('/daily-content')
                // document.querySelector('.header').style.display = 'block'
                setCurrentQuestion(11)
                // handleNextQuestion()
            }, 4000)
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "hidden"
        handleNextQuestion()

    };

    const handleOpenonboardingPopup = () => {
        setShowPopup(true);
        document.getElementById('onboarding-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "visible"
    };

    const handleCloseonboardingPopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popupContainer")[0].style.display =  "none"
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "hidden"

    };

    const handleCloseRelapsePopup = () => {
        navigate('/daily-content')
        document.querySelector('.header').style.display = 'block'
    }


    const renderFormonboarding = () => {
        try{
            const currentQ = questionsonboarding[currentQuestion];
            const { question, options } = currentQ;

            return (
                <div className="formContainer" >
                    <div className="button-group" style={{ float: 'right' }}>
                        {/* <button onClick={handleCloseonboardingPopup}> 
                            <img style={{ width: '9px', height: '10px', paddingTop: '0.2rem' }} src={closeBttn} alt="CloseModalBttn" />
                        </button> */}
                        <button onClick={handleCloseonboardingPopup} style={{border:'none'}}> 
                            <img className="closeBttn" src={closeBttn} alt="CloseModalBttn" />
                        </button>
                    </div>
                    <h2 style={{ textAlign: 'center', marginTop: '3rem', marginBottom: '1rem' }}>{question}</h2>
                    {currentQ.assets}
                    {currentQ.errorMessage && <p className="message" style={{  marginTop: '-10rem' }}> { currentQ.errorMessage } </p>}
                    <div className="popupButtonGroup">
                    {(currentQuestion > 0 && currentQuestion < questionsonboarding.length - 1) && (
                        // <button className="popupNavigationBttn" onClick={handlePreviousQuestion}>Previous</button>
                        <button className="popupNavigationBttn" onClick={handlePreviousQuestion} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    )}
                    {currentQuestion > 0 && currentQuestion < questionsonboarding.length - 3 ? (
                        // <button className="popupNavigationBttn" onClick={handleNextQuestion}>Next</button>
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion >= questionsonboarding.length - 3 ? (
                        // <button id="onboardingSubmit" className="popupNavigationBttn" onClick={handleSubmitonboarding}>Submit</button>
                        <button id="relapseSubmit" className="popupNavigationBttn" onClick={handleSubmitonboarding} style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    </div>
                </div>
            );
        }
        catch{
            //console.log('someerro yo onboarding')
        }
    };
    
    // End of Popup
    
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);
    const todayString = today.toDateString();

    useEffect(() => {
        setOnboardingForm()
        document.querySelector('.header').style.display = 'none'
     }, []);
 

    return (
        <div className="wrapper" style={{ marginTop: '2.5rem', marginLeft: '1.5rem', marginRight: '1.5rem'}}>
            <div className="dailyPopup">
                {/* <button onClick={handleOpenPopup}>hello</button> */}
                {/* #4490C3 */}
                <div className="popupContainer"  id="onboarding-popup"  style={{ display: 'none' }}>{renderFormonboarding()}</div>
            </div>
            <div className="container" id="learningContainer" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <div style={{ textAlign: 'center', marginTop: '7rem'}}>
                    {/* <h5 id="todayInfo" style={{ textAlign: 'center' }}> Today: {todayString} </h5> */}
                    <h2>Welcome to <br/>Trampoline Health 🧘‍♀️💻 </h2>
                </div>
                <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"3.5rem", position: 'relative', bottom: '2rem', textAlign: 'center' }}>
                    <h6>This form is estimated to take 7 minutes. </h6>
                    <button className="homeBttn" style={{ marginTop:'1rem', background:"#549ACC"  }} onClick={handleOpenonboardingPopup}>Get Started 🚀 </button>
                </div>
            </div>
        </div>
    )
}


export default OnboardingDemo;